import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'

const IconBack: React.FC = () => {
  const navigate = useNavigate()
  const {
    settings: { language },
  } = useSelector((state: RootState) => state.settings)
  const isRTL = language === 'ar'

  const handleBack = () => {
    navigate('/home')
  }

  return (
    <button
      onClick={handleBack}
      className="w-[35px] h-[35px] bg-white rounded-[10px] flex items-center justify-center shadow-md hover:shadow-lg transition-shadow"
      style={{
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.26)',
      }}
    >
      {isRTL ? <ArrowRight className="w-4 h-4 text-gray-700" /> : <ArrowLeft className="w-4 h-4 text-gray-700" />}
    </button>
  )
}

export default IconBack

